<footer>
  <div class = "row" style = "width: 100%; margin: auto; text-align: center;">
    <div class = "col-1 col-sm-3">

    </div>
    <div class = "col-10 col-sm-4 footerRow" style = "text-align: center">
      <!-- <div class = " lstItem">
      <div class = "row itemContainer" [class] = "faqPage" (click) = "changeColor('faq')" routerLink="/user/rang-list" style = "margin: auto; text-align: center">
        <div class = "col-12">
          <img *ngIf = "faqPage == 'notActive'" style = "width: 30px; height: 30px;" src = "https://firebasestorage.googleapis.com/v0/b/leste-mobile.appspot.com/o/rangListGrey.png?alt=media&token=f78d7c85-ef89-4362-9ae8-e7b5ac715407">
          <img *ngIf = "faqPage == 'active'" src = "https://firebasestorage.googleapis.com/v0/b/leste-mobile.appspot.com/o/webIcons%2FrangListGreen.png?alt=media&token=7b97c70e-250b-4ca2-959e-0b10655c7bbf">
        </div>
        <div class = "col-12 footerLabel">
          {{labels.lblRangList}}
        </div>
      </div>
    </div> -->
    <!--<div class = " lstItem">
      <div class = "row itemContainer" [class] = "calendar" (click) = "changeColor('notifications')" style = "margin: auto; text-align: center">
        <div class = "col-12 imgCol">
          @if (calendar == 'notActive') {
            <img class = "img" src = "./assets/icons/VectornotificationsIconBlack.png" alt = "Notification icon">
          }
          @if (calendar == 'active') {
            <img class = "img" src = "./assets/icons/notifGreen.png" alt = "Notification icon">
          }
          @if (hasNotifications) {
            <span class="mx-2" style="color: red">{{ notificationNumber }}</span>
          }
        </div>
        <div class = "col-12 footerLabel">
          {{labels.lblNotifications}}
        </div>
      </div>
    </div>-->
    <div class = "lstItem">
      <div class = "row itemContainer" [class] = "homePage" (click) = "changeColor('home')" routerLink="/user/dashboard" style = "margin: auto; text-align: center">
        <div  class = "col-12 imgCol">
          @if (homePage == 'notActive') {
            <img class = "img" src = "./assets/icons/GrouptrainingsIconBlack.png" alt = "Training icon">
          }
          @if (homePage == 'active') {
            <img class = "img" src = "./assets/icons/trainingsGreen.png" alt = "Training icon">
          }
        </div>
        <div class = "col-12 footerLabel">
          {{labels.lblTrainings}}
        </div>
      </div>
    </div>
    <!-- <div class = "lstItem">
    <div class = "row itemContainer" [class] = "messagesPage" (click) = "changeColor('messages')" routerLink="/user/messages" style = "margin: auto; text-align: center">
      <div class = "col-12">
        <img *ngIf = "messagesPage == 'notActive'" src = "https://firebasestorage.googleapis.com/v0/b/leste-mobile.appspot.com/o/webIcons%2FchatGrey.png?alt=media&token=e3c4c184-7beb-4a66-a198-3b685acb4057">
        <img *ngIf = "messagesPage == 'active'" src = "https://firebasestorage.googleapis.com/v0/b/leste-mobile.appspot.com/o/webIcons%2FchatGreen.png?alt=media&token=60515b54-36f7-4097-8095-195ee09caef8">
      </div>
      <div class = "col-12 footerLabel">
        {{labels.lblChatRoom}}
      </div>
    </div>
  </div> -->
  <div class = " lstItem">
    <div class = "row itemContainer" [class] = "profilePage" (click) = "changeColor('profile')" routerLink="/user/user-profile" style = "margin: auto; text-align: center">
      <div class = "col-12 imgCol">
        @if (profilePage == 'notActive') {
          <img class = "img" src = "./assets/icons/VectorprofileIconBlack.png" alt = "Profile icon">
        }
        @if (profilePage == 'active') {
          <img class = "img" src = "./assets/icons/profileGreen.png" alt = "Profile icon">
        }
      </div>
      <div class = "col-12 footerLabel">
        {{labels.lblProfile}}
      </div>
    </div>
  </div>
</div>
<div class = "col-1 col-sm-4"></div>
</div>
</footer>
